import "./styles.less";

import React, { MouseEvent, useContext, useState } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { useIsAuthModalShowing } from "../../../../../GlobalHooks/useIsAuthModalShowing";
import { Button } from "shared-components/Components/Buttons/web";
import { MessageIcon } from "shared-components/Components/CustomIcons/MessageIcon/web";

import dynamic from "next/dynamic"
const ModalConsulta = dynamic(() => import("./ModalConsulta").then(mod => mod.ModalConsulta), { ssr: false });

export const FormButton = ({
	id,
	size = "middle",
	type = "primary",
	defaultMessage = "Hola, vi esta propiedad en InfoCasas y quiero que me contacten. Gracias.",
	isDisabledProperty = false,
	isInListing = false,
	sizeCard = "default",
}: {
	id: string;
	size?: any;
	type?: any;
	defaultMessage?: string;
	isDisabledProperty?: boolean;
	isInListing?: boolean;
	sizeCard?: string;
}) => {
	const { isAuthModalShowing } = useIsAuthModalShowing();
	const [modal, setModal] = useState(false);
	const [hasBeenOpen, setHasBeenOpen] = useState(false)
	// const GA = useGoogleAnalytics();
	const clickHandler = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		// GA.Event({
		// 	category: "user_event",
		// 	action: "lead_btn_clicked",
		// });
		setModal(true);
		setHasBeenOpen(true);
	};

	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description,
		);
	}
	const { country_code } = useContext(ConfigStateContext);

	if (country_code === "ce3") defaultMessage = "Hola, vi esta propiedad en Casas En El Este y quiero que me contacten. Gracias."

	return (
		<>
			<Button onClick={e => clickHandler(e)} style={{ width: "100%" }}>
				<MessageIcon /> Consultar
			</Button>


			{hasBeenOpen &&
				<ModalConsulta
					defaultMessage={defaultMessage}
					modal={modal}
					isAuthModalShowing={isAuthModalShowing}
					closeModal={() => setModal(false)}
					onSuccess={() => {
						setModal(false);
						handleClickShowNotification({
							type: "success",
							message: "¡Gracias por tu consulta!",
							description: "Tus datos han sido enviados con éxito. En las próximas horas nos contactaremos contigo para darte más información.",
						});
					}}
					id={id}
					isInListing={isInListing}
				/>
			}
		</>
	);
};


